import React from 'react';
import { CloseSquareOutlined } from '@ant-design/icons';
import styles from './CloseIconButton.module.scss';
import SmallButton from '../SmallButton/SmallButton';

interface CloseIconButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const CloseIconButton: React.FC<CloseIconButtonProps> = (props) => {
  const { onClick, disabled, className } = props;

  return (
    <SmallButton className={className} onClick={onClick} disabled={disabled}>
      <CloseSquareOutlined className={styles.closeIcon} />
    </SmallButton>
  );
};

export default CloseIconButton;
